import withDraft from '@/utils/draftHelper';
import actions from '@/requests/tasks/constants';
import { taskUserGroups } from './state';

const resetTaskUserGroups = withDraft((draft) => {
  draft.userGroups.tasks = taskUserGroups();
});

export default {
  [actions.HIDE_MANAGE_TASK]: resetTaskUserGroups,
  [actions.SHOW_MANAGE_REQUEST_TASK_SUCCESS]: resetTaskUserGroups,
};
